import React, { FC } from 'react';
import { Outlet } from 'react-router-dom';

import Box from '@mui/material/Box';

import Navbar from '../navbar/navbar.component';
import ProtectedRoute from 'utils/routes/ProtectedRoute';
import { MeetingStatusContextProvider } from 'utils/contexts/meeting-status-context';

const PrivateLayout: FC = () => {
  return (
    <ProtectedRoute>
      <Box
        id='private-layout-page'
        sx={{
          bgcolor: 'background.default',
          height: '100%',
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <MeetingStatusContextProvider>
          <Navbar />
          <Box sx={{ marginTop: '100px' }}>
            <Outlet />
          </Box>
        </MeetingStatusContextProvider>
      </Box>
    </ProtectedRoute>
  );
};

export default PrivateLayout;
